import React from "react";
import {
  Document,
  Page,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Header from "./Header";
//import Report from "./Report-Details";
import Report from "./Report-NewDetails";
import ReportCompRollUp from "./Report-CompetencyRollUp";
import ReportTraining from "./Report-RecTraining";
import styles from "../../css";
import { MDBBtn as Button, MDBSpinner as Spinner } from "mdb-react-ui-kit";

const ReportPreview = ({ profile, imageUrl, ksa }) => {
  return (
    <div
      style={{
        flexGrow: 1,
        height: "600px",
      }}
    >
      <PDFViewer
        showToolbar={false}
        style={{
          width: "100%",
          height: "90%",
        }}
      >
        <ReportTemplate userProfile={profile} chartImage={imageUrl} ksa={ksa} />
      </PDFViewer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingTop: "5px",
        }}
      >
        <PDFDownloadLink
          document={
            <ReportTemplate
              userProfile={profile}
              chartImage={imageUrl}
              ksa={ksa}
            />
          }
          fileName={`ADDA Detailed Report - ${profile["employee"]["name"]}.pdf`}
        >
          {({ loading }) =>
            loading ? (
              <Spinner grow color="primary">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <Button color="primary">Export PDF</Button>
            )
          }
        </PDFDownloadLink>
      </div>
    </div>
  );
};
// Create Document Component
const ReportTemplate = ({ userProfile, chartImage, ksa }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header />
        <Report userProfile={userProfile} ksa={ksa} />
        {/* <LeftSection profile={profile} />
        <RightSection about={profile.about} /> */}
      </Page>
      <Page size="A4" style={styles.page}>
        <Header />
        <ReportCompRollUp chartImage={chartImage} />
      </Page>
      <Page size="A4" style={styles.page}>
        <Header />
        <ReportTraining userProfile={userProfile} />
      </Page>
    </Document>
  );
};

export default ReportPreview;
